/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./upload-cover-button.vue?vue&type=template&id=36ad2c22&scoped=true&"
import script from "./upload-cover-button.vue?vue&type=script&lang=ts&"
export * from "./upload-cover-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ad2c22",
  null
  
)

export default component.exports